






import { Vue, Component } from 'vue-property-decorator';
import { Button } from 'vant';
import OSS from 'ali-oss';
import { genHash } from '@/common/ts/common';
import { getOssSignature } from '@/api/api';

Vue.use(Button);

const imgCdnPrefix = 'https://image2.cqcb.com/';

@Component
export default class AnyUploader extends Vue {
  selectFile() {
    const inputEl = document.createElement('input');
    inputEl.type = 'file';
    inputEl.addEventListener('change', async (e: Event) => {
      const payloadFiles = (e.target as HTMLInputElement).files!;
      console.log('change', payloadFiles);
      const ret = await this.uploadOssWithSignature(payloadFiles[0]);
      console.log(ret);
    });
    inputEl.click();
  }

  async uploadOssWithSignature(fileData: any) {
    return new Promise(async (resolve, reject) => {
      // 获取签名
      const res: any = await getOssSignature();

      // 实例化oss
      const OssClient = new OSS({
        accessKeyId: res.AccessKeyId,
        accessKeySecret: res.AccessKeySecret,
        stsToken: res.SecurityToken,
        region: 'oss-cn-hangzhou',
        bucket: res.Bucket,
      });
      const fileTypeArr = fileData.name.split('.');
      const type = fileTypeArr[fileTypeArr.length - 1];
      // 上传的文件命名
      const fileName = `${res.Dir}${genHash()}-${Date.now()}.${type}`.replace(
        '&',
        '',
      );

      try {
        const result: any = await OssClient.put(fileName, fileData);
        resolve(imgCdnPrefix + result.name);
      } catch (result) {
        console.log('error occur:', result);

        reject('fail');
      }
    });
  }
}
